import {Button} from "primereact/button";
import {Card} from "primereact/card";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {InputText} from "primereact/inputtext";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import React, {useCallback, useEffect, useState} from "react";
import authService from "../../services/auth.service";
import salaService from "../../services/sala.service";
import DialogSala from "./dialogSala.component";

const SalaPesquisa = ({ mostrarMensagem }) => {
  const permissaoCadastro = authService.checkIfHasPermissao(["CAD_SALA"]);
  const permissaoInativar = authService.checkIfHasPermissao(["ADM_SUPER", "INA_SALA"]);
  const [loading, setLoading] = useState(true);
  const [salas, setSalas] = useState([]);
  const [dialogSalaVisible, setDialogSalaVisible] = useState(false);
  const [salaAlteracao, setSalaAlteracao] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 5,
    page: 0,
    sortField: "nome",
    sortOrder: true,
    filters: {
      nome: { value: "", matchMode: "contains" },
    },
  });

  const pesquisarSalas = useCallback(() => {
    setLoading(true);
    salaService
      .pesquisarSalas(lazyState)
      .then((result) => {
        setTotalRecords(result.total);
        setSalas(result.salas);
        setLoading(false);
      })
      .catch((error) => {
        mostrarMensagem(error, "error");
        setLoading(false);
      });
  }, [lazyState, mostrarMensagem]);

  useEffect(() => {
    pesquisarSalas();
  }, [pesquisarSalas]);

  const onPage = (event) => {
    setlazyState(event);
  };

  const confirmarInativarSala = (sala) => {
    confirmDialog({
      message: `Deseja realmente inativar a sala ${sala.nome}?`,
      header: "Confirmação de Inativação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => inativarSala(sala),
    });
  };

  const confirmarAtivarSala = (sala) => {
    confirmDialog({
      message: `Deseja realmente ativar a sala ${sala.nome}?`,
      header: "Confirmação de Ativação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => ativarSala(sala),
    });
  };

  const inativarSala = async (sala) => {
    try {
      await salaService.inativarSala(sala);
      mostrarMensagem("Sala inativada com sucesso!", "success");
      pesquisarSalas();
    } catch (error) {
      mostrarMensagem(error, "error");
    }
  };

  const ativarSala = async (sala) => {
    try {
      await salaService.ativarSala(sala);
      mostrarMensagem("Sala ativada com sucesso!", "success");
      pesquisarSalas();
    } catch (error) {
      mostrarMensagem(error, "error");
    }
  };

  const statusBodyTemplate = (rowData) => {
    return (
        <span className={`status-badge status-${rowData.ativo ? 'ativo' : 'inativo'}`}>
        {rowData.ativo ? 'Ativo' : 'Inativo'}
      </span>
    );
  };

  return (
    <>
      <ConfirmDialog/>
      <Card title="Salas">
        <div className="grid">
          <div className="field col-fixed">
            <Button
              label="Novo"
              icon="pi pi-plus"
              severity="success"
              className="flex-none"
              onClick={() => {
                setSalaAlteracao(null);
                setDialogSalaVisible(true);
              }}
              disabled={!permissaoCadastro}
            />
          </div>
          <div className="field col" style={{ minWidth: "200px" }}>
            <div className="flex w-full">
              <span className="p-input-icon-left w-full mr-2">
                <i className="pi pi-search" />
                <InputText
                  onChange={(e) => setlazyState({ ...lazyState, nome: e.target.value })}
                  placeholder="Procurar..."
                  className="w-full"
                />
              </span>

              <Button icon="pi pi-refresh" onClick={() => pesquisarSalas()} className="flex-none" severity="info" />
            </div>
          </div>
        </div>
        <DataTable
          paginator
          rows={lazyState.rows}
          rowsPerPageOptions={[5, 10, 25, 50]}
          emptyMessage="Nenhum registro encontrado!"
          dataKey="id"
          loading={loading}
          first={lazyState.first}
          totalRecords={totalRecords}
          value={salas}
          onPage={onPage}
          lazy
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          filters={lazyState.filters}
        >
          <Column field="nome" header="Nome" />
          <Column field="capacidade" header="Capacidade" />
          <Column field="ativo" header="Status" body={statusBodyTemplate}/>
          <Column
            style={{ width: "1rem" }}
            field="edit"
            body={(rowData) => (
              <Button
                icon="pi pi-pencil"
                size="small"
                onClick={() => {
                  setSalaAlteracao(rowData);
                  setDialogSalaVisible(true);
                }}
              />
            )}
          />
          {permissaoInativar && (
              <Column
                  style={{width: "1rem"}}
                  field="actions"
                  body={(rowData) => (
                      rowData.ativo ? (
                          <Button
                              icon="pi pi-trash"
                              size="small"
                              severity="danger"
                              onClick={() => confirmarInativarSala(rowData)}
                          />
                      ) : (
                          <Button
                              icon="pi pi-check"
                              size="small"
                              severity="success"
                              onClick={() => confirmarAtivarSala(rowData)}
                          />
                      )
                  )}
              />
          )}
        </DataTable>
      </Card>

      <DialogSala
        dialogSalaVisible={dialogSalaVisible}
        setDialogSalaVisible={setDialogSalaVisible}
        onSaveMetodo={() => {
          mostrarMensagem("Sala salva com sucesso!", "success");
          pesquisarSalas();
        }}
        salaAlteracao={salaAlteracao}
        mostrarMensagem={mostrarMensagem}
      />
    </>
  );
};

export default SalaPesquisa;
